import * as React from 'react';
import type { OrderDetails } from '@/types';
import { ShowDate } from '@/components/atoms/ShowDate';
import { ShowAsDollars } from '@/components/atoms/ShowNumberAsDollars';
import { Card, CardContent } from '@/components/atoms/card';
import { ViewOrder } from './ViewOrder';
import { StatusBadge } from '../atoms/StatusBadge';

type OrdersListProps = {
  orders: OrderDetails[];
};

export function OrdersList(props: OrdersListProps) {
  const [viewOrderIsOpen, setViewOrderIsOpen] = React.useState(false);
  const [orderId, setOrderId] = React.useState<string | null>(null);

  console.log(props.orders);
  const handleViewOrder = (order: OrderDetails) => () => {
    setViewOrderIsOpen(true);
    setOrderId(order._id);
  };

  return (
    <div className="space-y-4">
      {props.orders.map((order: OrderDetails) => (
        <Card onClick={handleViewOrder(order)} key={`__order__${order._id}__`} className="w-full">
          <CardContent>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row justify-between">
                <div>
                  <div className="text-sm text-muted-foreground">Order No</div>
                  <h3 className="text-lg">{order.orderNo}</h3>
                </div>
                <div>
                  <div className="text-sm text-muted-foreground">Order Date</div>
                  <div className="text-lg">
                    <ShowDate date={order.orderDate} />
                  </div>
                </div>
                <div>
                  <div className="text-muted-foreground">Total</div>
                  <ShowAsDollars number={order.totalAsCents} />
                </div>
              </div>
              <div className="flex flex-row justify-between">
                <StatusBadge status={order.status} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
      <ViewOrder isOpen={viewOrderIsOpen} onOpenChange={setViewOrderIsOpen} orderId={orderId} />
    </div>
  );
}
